export const accountRetentionGerman = {
  deactivateDescription:
    'Alle laufenden Sitzungen werden beendet. Du kannst das Konto innerhalb von 90 Tagen wieder freigeben. Danach werden die persönlichen Kontodaten gelöscht; bestehende Vorgänge und Belege bleiben erhalten.',
  bulkHint:
    'Gesperrte Konten können 90 Tage lang wieder freigegeben werden. Danach werden die persönlichen Kontodaten gelöscht.',
  expired:
    'Die Wiederherstellungsfrist von 90 Tagen ist abgelaufen. Nach der automatischen Kontobereinigung ist eine neue Einladung möglich.',
};

export const accountRetentionEnglish = {
  deactivateDescription:
    'All current sessions end. You can restore the account within 90 days. After that, personal account data is deleted; existing business records and documents remain.',
  bulkHint:
    'Deactivated accounts can be restored for 90 days. After that, personal account data is deleted.',
  expired:
    'The 90-day recovery period has expired. A new invitation is possible after automatic account cleanup.',
};
